import {HostDTO, HostState, LegalForm} from '@domain/host/host.dto';
import {StringUtil} from '@shared/util/string.util';
import {Choice} from '@shared/form/choice/choice';
import {FactoryIcon, HouseHeartIcon, LandmarkIcon, UserIcon} from 'lucide-angular';
import {ActivityDTO, ActivityState} from '@domain/activity/activity.dto';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';

export class HostUtil {

  public static getSlug(host: HostDTO | null): string | null {
    if (!host?.id) {
      return null;
    }
    const data: string[] = [];
    const title = host.name;
    if (title) {
      data.push(title);
    }
    // TODO: an host can have a venues (in addition to activity venues)
    // const venue = ActivityVenuePipe.formatAddress(activity.venue, false);
    // if (venue) {
    //   data.push(venue);
    // }
    let str = StringUtil.slugify(data.join(StringUtil.SLUG_SPACER)) ?? '';
    if (str.length > 0) {
      str += StringUtil.SLUG_SEPARATOR;
    }
    str += host.id;
    return str;
  }

  public static getLegalFormChoices(): Choice<LegalForm>[] {
    return [
      {
        value: LegalForm.Nonprofit,
        text: 'Une organisation sans but lucratif (association)',
        icon: HouseHeartIcon
      },
      {
        value: LegalForm.Individual,
        text: 'Un individu (personne physique)',
        icon: UserIcon
      },
      {
        value: LegalForm.Business,
        text: 'Une Société commerciale (SA, SàRL)',
        icon: FactoryIcon
      },
      {
        value: LegalForm.Public,
        text: 'Une structure publique (commune, école, service)',
        icon: LandmarkIcon
      }
    ];
  }

  public static hasContactInfo(host: HostDTO | null): boolean {
    return !!host?.messaging || !!host?.webUrl || !!host?.fbUrl || !!host?.igUrl;
  }

  public static getImproveMessages(host: HostDTO | null): string[] {
    const msgs: string[] = [];
    if (!host) {
      return msgs;
    }
    if (host?.description === null) {
      msgs.push("Cette organisation n'a pas de description.");
    }

    if (!host?.cover) {
      msgs.push("Cette organisation n'a pas d'image d'illustration.");
    }
    if (!this.hasContactInfo(host)) {
      msgs.push(`Les informations de contact sont manquantes et les personnes intéressées ne pourront pas contacter ${host?.name} facilement.`)
    }
    return msgs;
  }

  private static readonly BADGE_CLASS_MAP = {
    [HostState.Active]: 'text-bg-success',
    [HostState.Invited]: 'text-bg-primary',
    [HostState.Registered]: 'text-bg-primary',
    [HostState.Disabled]: 'text-bg-light',
    [HostState.Deleting]: 'text-bg-dark'
  }
  public static getStateBadgeClass(state: HostState | null | undefined): string {
    return state ? HostUtil.BADGE_CLASS_MAP[state] : 'text-bg-danger';
  }

}
